export enum MTooltipPosition {
  Left = 'left',
  Right = 'right',
  Bottom = 'bottom',
  Top = 'top',
}
